module.exports = __webpack_public_path__ + "img/product-core-3.378b728b.png";